import ProductionQualityInspectionDimension from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimension';

export default class ProductionQualityInspectionDimensionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.productionQualityInspectionNumber = '';
		this.workOrderProcessId  = '';
		this.workOrderProcessWorkOrderProcessNumber = '';
		this.productionDateFrom = '';
		this.productionDateTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			productionQualityInspectionNumber : '0',
			workOrderProcessId : '0',
			workOrderProcessWorkOrderProcessNumber : '0',
			productionDateFrom : '0',
			productionDateTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}